import { NPRequestStatus } from '@gtintel/platform-types';
export const NPRequestStatusBackground = {
  0: '#fff1cc',
  1: '#d5fafd',
  2: '#ffebed',
  3: '#e2f6d6',
  4: '#f2f4f6',
  5: '#e3f3e3'
};
export const NPRequestStatusColor = {
  0: '#d89d00',
  1: '#2babb9',
  2: '#d0021b',
  3: '#59ad27',
  4: '#778ca2',
  5: '#4caf50'
};
export const getWaitStepName = status => {
  switch (status) {
    case NPRequestStatus.Accepted:
      return 'Accepted';
    case NPRequestStatus.Declined:
      return 'Declined';
    case NPRequestStatus.Cancelled:
      return 'Cancelled';
    default:
      return 'Wait';
  }
};
export const getAssignStepName = status => {
  switch (status) {
    case NPRequestStatus.Assigned:
    case NPRequestStatus.Finished:
      return 'Activated';
    case NPRequestStatus.AcceptedCancelled:
      return 'Cancelled';
    default:
      return 'Activate';
  }
};
export const getSendStepName = status => {
  switch (status) {
    case NPRequestStatus.Sent:
      return 'Sent';
    default:
      return 'Send';
  }
};
export const getFinishedStepName = status => {
  switch (status) {
    case NPRequestStatus.Finished:
    case NPRequestStatus.Submitted:
      return 'Finished';
    default:
      return 'Finish';
  }
};
export const calculateTotalCost = (status, assignmentCosts, fee) => {
  return [NPRequestStatus.Draft, NPRequestStatus.Sent].includes(status) ? +assignmentCosts : +assignmentCosts + +fee;
};